import { z } from "zod";
import { errorEnvelopeSchema } from "@eaf/contracts";

export class ApiClientError extends Error {
  public constructor(
    public readonly status: number,
    public readonly code: string,
    message: string
  ) {
    super(message);
  }
}

export async function publicApi<T>(path: string, schema: z.ZodType<T>): Promise<T> {
  const response = await fetch(`/api/v1${path}`, { headers: { Accept: "application/json" } });
  const payload: unknown = await response.json().catch(() => null);
  if (!response.ok) {
    const parsed = errorEnvelopeSchema.safeParse(payload);
    throw new ApiClientError(
      response.status,
      parsed.success ? parsed.data.error.code : "API_ERROR",
      parsed.success ? parsed.data.error.message : "The service is unavailable."
    );
  }
  const envelope = z
    .object({ ok: z.literal(true), data: schema, error: z.null(), requestId: z.string() })
    .parse(payload);
  return envelope.data;
}
